import React, { useState, useEffect, useRef } from 'react';
import { auth, RecaptchaVerifier, signInWithPhoneNumber } from './firebase';
import { initializeApp } from 'firebase/app';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './RegisterForm.css'; // Import the CSS file


interface RegisterFormProps {
    onRegister: (confirmationResult: any) => void;
}

const RegisterForm: React.FC<RegisterFormProps> = ({ onRegister }) => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [error, setError] = useState<string | null>(null);
    const recaptchaVerifier = useRef<RecaptchaVerifier | null>(null);

    useEffect(() => {
        window.onunhandledrejection = function (event) {
            console.log(event.promise);
            console.log(event.reason);
        };

        recaptchaVerifier.current = new RecaptchaVerifier(auth, 'recaptcha-container', {
            'size': 'invisible',
            'callback': (response: string) => {
                // reCAPTCHA solved, allow signInWithPhoneNumber.
                //console.log(response);
            }
        });

    }, [auth]);

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        if (recaptchaVerifier.current) {
            signInWithPhoneNumber(auth, phoneNumber, recaptchaVerifier.current)
                .then((confirmationResult) => {
                    onRegister(confirmationResult);
                })
                .catch((err) => {
                    if (err instanceof Error) {
                        console.error(err.message);
                        setError(`Failed to send SMS: ${err.message}`);
                    } else {
                        console.error(err);
                        setError('Failed to send SMS');
                    }
                });
        }
    };

    return (
        <form onSubmit={handleSubmit} className="registerForm">
            <PhoneInput
                placeholder="Enter phone number"
                value={phoneNumber}
                onChange={(value) => setPhoneNumber(value || '')}
                defaultCountry="US"
            />
            <div id="recaptcha-container"></div>
            {error && <p>{error}</p>}
            <button type="submit">Submit</button>
        </form>
    );
}

export default RegisterForm;
